<template>
  <el-dialog
    title="Open360 Sync"
    :visible.sync="isVisible"
    width="30%"
    :close-on-click-modal="false"
    center
  >
    <span
      v-if="!isShowingHistory"
      class="dialog-content"
    >
      <el-transfer
        v-model="selected"
        :data="migratable"
        :titles="['Available', 'Selected']"
        target-order="original"
      />
    </span>
    <span
      v-else
      :loading="isLoadingHistory"
    >
      <el-table
        :data="history"
        style="width: 100%"
        :loading="isLoadingHistory"
      >
        <el-table-column
          prop="resource"
          label="Resource"
        />
        <el-table-column
          prop="created_at"
          label="Date"
        />
        <el-table-column
          prop="profile"
          label="User"
          :formatter="row => row.profile ? row.profile.name : 'N/A'"
        />
      </el-table>
    </span>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        @click="isShowingHistory = !isShowingHistory"
      >
        View {{ isShowingHistory ? 'Sync' : 'History' }}
      </el-button>
      <el-button @click="$emit('close')">Cancel</el-button>
      <el-button
        type="primary"
        @click="startSync"
      >
        Start
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'MigrateDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShowingHistory: false,
      history: [],
      isLoadingHistory: false,
      migratable: [
        {
          key: 'account',
          label: 'Account',
          disabled: false
        },
        {
          key: 'teams',
          label: 'Teams',
          disabled: false
        },
        {
          key: 'users',
          label: 'Users',
          disabled: false
        },
        {
          key: 'contacts',
          label: 'Contacts',
          disabled: true
        },
        {
          key: 'items',
          label: 'Items',
          disabled: false
        },
        {
          key: 'address-book',
          label: 'Address Book',
          disabled: false
        },
        {
          key: 'dg',
          label: 'Dangerous Goods',
          disabled: true
        },
        {
          key: 'search-sync',
          label: 'Sync Search',
          disabled: false
        }
      ],
      selected: []
    }
  },
  watch: {
    isShowingHistory (newVal) {
      if (newVal) {
        // Logic to fetch and display sync history
        this.fetchSyncHistory()
      }
    }
  },
  methods: {
    async fetchSyncHistory () {
      this.isLoadingHistory = true
      // Placeholder for fetching sync history logic
      // This could be an API call to get the history of previous syncs
      await this.$sdk.account_synclog.list(builder => {
        builder.page = 1
        builder.limit = 1000
        builder.order = 'created_at:desc'
        builder.context = { resource: 'account', id: this.$route.params.accountId }
      }).then(res => {
        this.history = res
        this.isLoadingHistory = false
      })
    },
    startSync () {
      const job = {
        name: 'open360.sync',
        parameters: {
          accountId: this.$route.params.accountId,
          resources: this.selected
        }
      }
      this.$sdk.job.create(job)
        .then(res => {
          this.$message({
            type: 'success',
            message: 'Sync job created successfully.'
          })
        })
        .finally(() => { this.$emit('close') })
    }
  }
}
</script>
<style scoped>
.dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
